import {useBoolean} from "@fluentui/react-hooks";
import {DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton} from "@fluentui/react";
import {FC, useEffect, useState} from "react";

interface DisplayErrorProps {
    error?: string;
}

export const DisplayError: FC<DisplayErrorProps> = ({error = ""}) => {
    const [showDialog, setDialog] = useState(false);


    useEffect(() => {
        if (error === "") {
            setDialog(false);
        } else {
            setDialog(true);
        }

    }, [error]);

    return (<Dialog
        onDismiss={() => {
            setDialog(false);
        }}
        dialogContentProps={{
            type: DialogType.normal,
            title: 'Unexpected Error',
            subText: error,
        }}
    >
        <DialogFooter>
            <PrimaryButton onClick={() => {
                setDialog(false);
            }} text="Okay"/>
        </DialogFooter>
    </Dialog>)

}